module.exports = __webpack_public_path__ + "img/multiple-users.8c97c594.svg";